import React, { useState } from "react"
import TableCustom from "../../components/TableCustom"
import { Alert, Button, CircularProgress, Grid, IconButton } from "@mui/material"
import Vista from "../../components/Vista"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import pdfChecklist from "../../pdfs/pdfChecklist"
import Servo from "../../services/servo"
import { useMessages } from "../../hooks/useMessages"
import { useHistory } from "react-router-dom"
import DescriptionIcon from "@mui/icons-material/Description"
import pdfCart from "../../pdfs/pdfCart"
import { useLocalStorage } from "../../hooks/useLocalStorage"

import { checklistListExpand, getChecklistDocumentData } from "../../services/checklistDocuments"

const busquedaDefault = {
  fechaInicio: "",
  fechaFinal: ""
}

const Checklists = ({ onClick, onKeyDown, ...props }) => {
  const [busqueda, setBusqueda] = useState({
    ...busquedaDefault
  })
  const [carro, setCarro] = useState("")
  const [empresa, setEmpresa] = useState("")
  const [area, setArea] = useState("")
  const { setMessages } = useMessages()
  const [documentLoading, setDocumentLoading] = useState(null)
  const [documentError, setDocumentError] = useState("")
  const openDocument = async (item, generate) => {
    if (documentLoading !== null) return
    // Abrir durante el clic evita el bloqueo de ventanas tras esperar la API.
    const preview = window.open("", "_blank")
    if (!preview) {
      setDocumentError("Permite las ventanas emergentes para abrir el documento.")
      return
    }
    preview.opener = null
    preview.document.title = "Preparando documento"
    preview.document.body.textContent = "Cargando checklist…"
    setDocumentLoading(item.idChecklist)
    setDocumentError("")
    try {
      const detail = await getChecklistDocumentData(item.idChecklist)
      const blob = await generate(detail)
      const url = window.URL.createObjectURL(blob)
      if (!preview.closed) preview.location.replace(url)
      window.setTimeout(() => window.URL.revokeObjectURL(url), 60000)
    } catch (error) {
      preview.close()
      setDocumentError(error.message || "No fue posible generar el documento.")
    } finally {
      setDocumentLoading(null)
    }
  }
  const [loadingButton, setLoadingButton] = useState(false)
  const history = useHistory()
  const [permiso] = useLocalStorage("permiso", null)
  const handleGenerarOrden = async (idChecklist) => {
    setLoadingButton(true)
    let body = {
      DatosOrdenServicio: {
        idChecklist: idChecklist
      }
    }

    let res = await Servo.post(
      "orden-servicios/guardar-datos-orden-servicio",
      body,
      "ordenServicios",
      true,
      history
    )
    if (res?.cuerpo) {
      setMessages(res?.cuerpo)
    }
    setLoadingButton(false)
  }

  let dataTable = {
    fecha: {
      nombre: "Fecha",
      content: (e) => {
        return e?.creado
      }
    },
    placa: {
      nombre: "Placas",
      content: (e) => {
        return e?.datoschecklists?.carros?.placas
      }
    },
    economico: {
      nombre: "Económico",
      content: (e) => {
        return e?.datoschecklists?.carros?.economico
      }
    },
    empresa: {
      nombre: "Empresa",
      content: (e) => {
        return e?.datoschecklists?.empresas?.nombre
      }
    },
    areaTrabajo: {
      nombre: "Proyecto",
      content: (e) => {
        return e?.datoschecklists?.areas?.nombre
      }
    },

    pdf: {
      nombre: "PDF",
      content: (item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%"
            }}
          >
            <IconButton aria-label="Abrir PDF del checklist" disabled={documentLoading !== null}
              onClick={() => openDocument(item, pdfChecklist)}>
              {documentLoading === item.idChecklist ? <CircularProgress size={20} /> : <PictureAsPdfIcon sx={{ color: "#157CC1" }} />}
            </IconButton>
          </div>
        )
      }
    },
    cartaResponsiva: {
      nombre: "Carta Responsiva",
      content: (item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%"
            }}
          >
            <IconButton aria-label="Abrir carta responsiva" disabled={documentLoading !== null}
              onClick={() => openDocument(item, pdfCart)}>
              <DescriptionIcon sx={{ color: "#157CC1" }} />
            </IconButton>
          </div>
        )
      }
    },

    generarOrden: {
      nombre: "Generar Orden",
      content: (e) => (
        <Button
          variant="contained"
          color="primary"
          disabled={permiso?.rol?.toLowerCase() === "jac"} // ⛔ Deshabilitar si es JAC
          onClick={() => {
            if (permiso?.rol?.toLowerCase() === "jac") return // ⛔ Evitar clic
            handleGenerarOrden(e.idChecklist)
          }}
          style={{
            opacity: permiso?.rol?.toLowerCase() === "jac" ? 0.5 : 1,
            cursor:
              permiso?.rol?.toLowerCase() === "jac" ? "not-allowed" : "pointer"
          }}
        >
          Generar Orden
        </Button>
      )
    }
  }

  let dataPdf = {
    fecha: {
      nombre: "Fecha",
      content: (e) => {
        return e?.creado
      }
    },
    placa: {
      nombre: "Placas",
      content: (e) => {
        return e?.datoschecklists?.carros?.placas
      }
    },
    economico: {
      nombre: "Económico",
      content: (e) => {
        return e?.datoschecklists?.carros?.economico
      }
    },
    empresa: {
      nombre: "Empresa",
      content: (e) => {
        return e?.datoschecklists?.empresas?.nombre
      }
    },
    areaTrabajo: {
      nombre: "Proyecto",
      content: (e) => {
        return e?.datoschecklists?.areas?.nombre
      }
    }
  }

  return (
    <Vista>
      {documentError && <Alert severity="error">{documentError}</Alert>}
      <TableCustom
        tipo="idChecklist"
        serverPagination
        serverFilters={{ resumen: 1, idCarro: carro?.idCarro, idEmpresa: empresa?.idEmpresa, idArea: area?.idArea }}
        filtroCustom={() => true}
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        dataTable={dataTable}
        dataPdf={dataPdf}
        fechaInicio={busqueda.fechaInicio}
        fechaFinal={busqueda.fechaFinal}
        buscador={[
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            key={1}
            sx={{
              order: "2",
              padding: "0 5px 0 0px",
              height: "80px",
              "@media (min-width: 900px)": {
                marginTop: "0px",
                marginBottom: "10px",
                order: "0"
              },
              "@media (max-width: 600px)": {
                padding: "0",
                margin: "0",
                orden: "0"
              }
            }}
          >
            <AutocompleteDeluxe
              labelToShow="Carros"
              labelProp="economico"
              nombre="carros"
              value={carro}
              setDato={setCarro}
            />
          </Grid>,
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            key={2}
            sx={{
              order: "2",
              padding: "0 5px 0 5px",
              height: "80px",
              "@media (min-width: 900px)": {
                marginTop: "0px",
                marginBottom: "10px",
                order: "0"
              },
              "@media (max-width: 600px)": {
                padding: "0",
                margin: "0",
                orden: "0"
              }
            }}
          >
            <AutocompleteDeluxe
              labelToShow="Empresa"
              labelProp="nombre"
              nombre="empresas"
              value={empresa}
              setDato={setEmpresa}
            />
          </Grid>,
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            key={3}
            sx={{
              order: "2",
              padding: "0px 0px 0px 5px",
              height: "80px",
              "@media (min-width: 1000px)": {
                marginTop: "0px",
                marginBottom: "10px",
                order: "0"
              },
              "@media (max-width: 600px)": {
                padding: "0",
                margin: "0",
                orden: "0"
              }
            }}
          >
            <AutocompleteDeluxe
              labelToShow="Áreas de trabajo"
              labelProp="nombre"
              nombre="areas"
              value={area}
              setDato={setArea}
            />
          </Grid>
        ]}
        expand={checklistListExpand}
        permisoCheck={"checklists"}
        nombreBusqueda={"placa"}
      />
    </Vista>
  )
}

export default Checklists
